
import { createStore } from "vuex";

import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import auth from './auth'
import sales from './sales'
import units from './units'
import companies from './companies'
import customers from './customers'
import cards from './cards'
import packages from './packages'
import announcements from './announcements'
import roles from './roles'
import payments from './payments'
import addresses from './addresses'
import unitCategories from './unitCategories'
import serviceCategories from './serviceCategories'
import services from './services'
import stockLocations from './stockLocations'
import suppliers from './suppliers'
import stockChanges from './stockChanges'
import shippings from './shippings'
import returns from './returns'
import platforms from './platforms'
import dashboard from './dashboard'
import staff from './staff'
import crtcreator from './Modules/crtcreator'
import modulesRegistry from './modulesRegistry'

export default createStore({
  modules: {
    app,
    appConfig,
    verticalMenu,
    auth,
    sales,
    units,
    companies,
    customers,
    cards,
    packages,
    announcements,
    roles,
    payments,
    addresses,
    unitCategories,
    serviceCategories,
    services,
    stockLocations,
    suppliers,
    stockChanges,
    shippings,
    returns,
    platforms,
    dashboard,
    staff,
    crtcreator,
    modulesRegistry,
  },
})
